var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lineBar"},[_c('div',{staticClass:"progress-container"},[_c('progress',{ref:"progressBar",staticClass:"amount-progress",style:({'height': _vm.height +'px'}),attrs:{"max":_vm.max},domProps:{"value":_vm.valueData}})])])}
var staticRenderFns = []

export { render, staticRenderFns }